import React, { useEffect, useMemo, useCallback } from 'react';
import { IItemForGetShortInfo, IGetCustomersShort } from 'types';
import { getCustomersShortInfo } from 'backend/customers';
import { useFetchData } from 'hooks/useFetchData';
import { MultipleSelect } from './MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './index.module.scss';

interface IProps {
	setIDsCustomer: (value: string[]) => void;
	setFetchedCustomers: (value: IItemForGetShortInfo[]) => void;
	IDsSelectedCustomer: string[];
}

export const CustomersMultipleSelect: React.FC<IProps> = React.memo(
	({ setIDsCustomer, setFetchedCustomers, IDsSelectedCustomer }) => {
		const { response, loading, refetch, responseError } = useFetchData<IGetCustomersShort, null>(
			getCustomersShortInfo,
		);

		useEffect(() => {
			response && setFetchedCustomers(response.data.customers);
		}, [response]);

		const handleRemove = useCallback(
			(id: string) => {
				const updatedSelectedItems = IDsSelectedCustomer.filter((el) => el !== id);
				setIDsCustomer(updatedSelectedItems);
			},
			[IDsSelectedCustomer, setIDsCustomer],
		);

		const customersList = useMemo(() => {
			return IDsSelectedCustomer.map((el) => {
				const label = response?.data.customers.find((item) => item.id === el)?.name || '';

				return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
			});
		}, [IDsSelectedCustomer, response?.data.customers, handleRemove]);

		return (
			<div className={style.container} data-test="CustomersMultipleSelect">
				<MultipleSelect
					customers={response?.data.customers || []}
					setIDsCustomer={setIDsCustomer}
					IDsSelectedCustomer={IDsSelectedCustomer}
					refetch={refetch}
					responseError={responseError}
					isLoading={loading}
				/>
				<div className={style.groupsList}>{customersList}</div>
			</div>
		);
	},
);
